import * as tslib_1 from "tslib";
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { EquipmentsAttachmentsApi } from './api/equipments-attachments.api';
import { EquipmentsApi } from './api/equipments.api';
import * as i0 from "@angular/core";
import * as i1 from "./api/equipments.api";
import * as i2 from "./api/equipments-attachments.api";
import * as i3 from "../../../../@fuse/components/progress-bar/progress-bar.service";
var EquipmentsService = /** @class */ (function () {
    function EquipmentsService(api, attachmentsApi, fuseProgressBarService) {
        this.api = api;
        this.attachmentsApi = attachmentsApi;
        this.fuseProgressBarService = fuseProgressBarService;
    }
    EquipmentsService.prototype.loadData = function (_a) {
        var where = _a.where, options = _a.options;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                this.fuseProgressBarService.show();
                return [2 /*return*/, this.api
                        .listEquipments({
                        orderBy: options.orderBy,
                        limit: options.limit,
                        offset: options.offset,
                        where: where
                    })
                        .toPromise()
                        .then(function (page) {
                        _this.fuseProgressBarService.hide();
                        var filtered = Boolean(!!where.segmentId_in ||
                            !!where.name_contains ||
                            !!where.locationId_in ||
                            !!where.number_contains ||
                            !!where.equipmentTypeId_in ||
                            !!where.warrantyStatusIn ||
                            !!where.warrantyStartDateLte ||
                            !!where.warrantyEndDateGte ||
                            where.archived !== false);
                        return {
                            items: page.items,
                            totalCount: page.totalCount,
                            filtered: filtered
                        };
                    })];
            });
        });
    };
    EquipmentsService.prototype.saveEquipment = function (id, equipmentInput) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (id) {
                    return [2 /*return*/, this.api.updateEquipment(id, equipmentInput).toPromise()];
                }
                return [2 /*return*/, this.api.createEquipment(equipmentInput).toPromise()];
            });
        });
    };
    EquipmentsService.prototype.saveEquipmentAttachment = function (id, equipmentAttachmentInput) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (id && equipmentAttachmentInput) {
                    return [2 /*return*/, this.attachmentsApi.updateEquipmentAttachment(id, equipmentAttachmentInput).toPromise()];
                }
                if (id && !equipmentAttachmentInput) {
                    return [2 /*return*/, this.attachmentsApi.deleteEquipmentAttachment(id).toPromise()];
                }
                return [2 /*return*/, this.attachmentsApi.createEquipmentAttachment(equipmentAttachmentInput).toPromise()];
            });
        });
    };
    EquipmentsService.prototype.getApprovalAndEquipment = function (_a) {
        var approvalId = _a.approvalId, equipmentQrCode = _a.equipmentQrCode;
        return this.api.getApprovalAndEquipment({
            approvalId: approvalId,
            equipmentQrCode: equipmentQrCode
        });
    };
    EquipmentsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EquipmentsService_Factory() { return new EquipmentsService(i0.ɵɵinject(i1.EquipmentsApi), i0.ɵɵinject(i2.EquipmentsAttachmentsApi), i0.ɵɵinject(i3.FuseProgressBarService)); }, token: EquipmentsService, providedIn: "root" });
    return EquipmentsService;
}());
export { EquipmentsService };
